import { NewMakerPropertyBaseProductConstantS } from '../../S/Constant/module/NewMakerPropertyBaseProductConstantS.js';

export const differentDeliveryFee = {
  getMessage: (maker_features) => {
    if (!maker_features) return;
    return maker_features[NewMakerPropertyBaseProductConstantS.DIFFERENT_DELIVERY_FEE]?.message;
  },
};
